import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  Injector,
  viewChild,
} from '@angular/core';
import {
  MibBreakpointService,
  MibButtonDirective,
  MibIconComponent,
  MibModalComponent,
} from '@medinbox/angular';
import { CaseFilterPanel } from '../case-filter-panel';
import { CaseLibraryStore } from '../case-library-store';

/** The phone's filters: choices apply as they are made, so the sheet stays open until closed. */
@Component({
  selector: 'mai-case-filters-dialog',
  imports: [MibModalComponent, MibButtonDirective, MibIconComponent, CaseFilterPanel],
  templateUrl: './case-filters-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseFiltersDialog {
  protected readonly library = inject(CaseLibraryStore);
  private readonly sizeClass = inject(MibBreakpointService).sizeClass;
  private readonly injector = inject(Injector);
  protected readonly modal = viewChild.required(MibModalComponent);
  private readonly panel = viewChild.required(CaseFilterPanel);

  /** Names how many cases the applied filters leave. */
  protected readonly resultsActionLabel = computed(() => {
    const count = this.library.cases()?.length ?? 0;
    return `Show ${count} ${count === 1 ? 'result' : 'results'}`;
  });

  constructor() {
    // The filters live in the page's aside off the phone layout.
    effect(() => {
      if (this.sizeClass() === 'expanded') {
        this.modal().close();
      }
    });
  }

  // The reset link disappears with the filters: the focus would fall to the body.
  protected resetFilters(): void {
    this.library.resetFilters();
    afterNextRender(() => this.panel().focusSort(), { injector: this.injector });
  }
}
